import React, { useState, useEffect } from "react";
// import { HomeNav } from "../../nav/homeNav";
import * as yup from "yup";
import { Logger } from "aws-amplify";

import { useAuth } from "../../../context/auth-context";
import { useSmallScreen } from "../../../hooks/useWindowSize";
import { Input } from "../../../tabin/components/input";
import { Button } from "../../../tabin/components/button";
import { isMobile } from "react-device-detect";
import { loginPath, forgotPasswordResetPath } from "../../main";
import { Link } from "../../../tabin/components/link";
import { useNavigate } from "react-router";

const logger = new Logger("Forgot password");

const emailSchema = yup.string().email("Please enter a valid email address").required("Please enter an email address");

export default () => {
    const { forgotPassword } = useAuth();
    const { isSmallScreen } = useSmallScreen();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");

    const [serverError, setServerError] = useState("");
    const [emailError, setEmailError] = useState("");

    const onChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
        setEmailError("");
        setServerError("");
    };

    const onSendResetLink = async () => {
        setLoading(true);
        let fieldsValid = true;

        try {
            await emailSchema.validate(email);
            setEmailError("");
        } catch (e) {
            setEmailError(e.message);
            fieldsValid = false;
        }

        if (fieldsValid) {
            try {
                await forgotPassword(email);
                logger.debug("Forgot password done");
                setLoading(false);
                navigate(forgotPasswordResetPath);
            } catch (e) {
                logger.debug("e", e);
                setServerError(e.message);
                setLoading(false);
            }
        } else {
            setLoading(false);
        }
    };

    const onBackToLogin = () => {
        navigate(loginPath);
    };

    const onEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            onSendResetLink();
        }
    };

    const emailInput = (
        <>
            <Input name="email" label="Email" type="text" onChange={onChangeEmail} onKeyPress={onEnter} value={email} error={emailError} />
        </>
    );

    const sendResetLinkButton = (
        <>
            <Button style={{ borderRadius: "8px", width: "100%", height: "52px" }} disabled={loading} onClick={onSendResetLink} loading={loading}>
                <div className="text-bold">SEND RESET LINK</div>
            </Button>
        </>
    );

    const content = (
        <>
            <div
                style={
                    !isSmallScreen
                        ? {
                              padding: "24px",
                              margin: "0 auto",
                              width: "448px",
                              border: "1px solid #e4e4e4",
                          }
                        : {}
                }
            >
                <div className="h2">Reset password</div>
                <div className="mb-3"></div>
                <div>Enter the email address associated with your account, and we’ll email you a verification code to reset your password.</div>
                <div className="mb-3"></div>
                {serverError && <div className="text-error mb-3">{serverError}</div>}

                {emailInput}
                <div className="mb-3"></div>
                <Link onClick={onBackToLogin}>Back to login</Link>
                <div className="mb-3"></div>
                {sendResetLinkButton}
            </div>
        </>
    );

    return (
        <>
            {/* <HomeNav /> */}
            <div
                style={{
                    minHeight: "100vh",
                    maxWidth: "1080px",
                    margin: "auto",
                    padding: "24px",
                    paddingTop: isSmallScreen ? "24px" : "40px",
                    paddingBottom: isMobile ? "80px" : "unset", // for tab nav
                }}
            >
                {content}
            </div>
        </>
    );
};
